var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:_vm.key,staticClass:"v-swiper",class:{ mobile: _vm.isMobile }},[_c('swiper',{staticClass:"swiper",attrs:{"options":{
      ..._vm.defaultOptions,
      navigation: {
        prevEl: `.prev${_vm.key}`,
        nextEl: `.next${_vm.key}`
      }
    }}},_vm._l((_vm.images),function(image,index){return _c('swiper-slide',{key:index,staticClass:"swiper-slide"},[(_vm.names[index])?_c('div',{staticClass:"swiper-text",domProps:{"innerHTML":_vm._s(_vm.names[index])}}):_vm._e(),_c('img',{staticClass:"swiper-img",attrs:{"src":image,"alt":"SWIPER"}})])}),1),_c('div',{class:`swiper-button-prev prev${_vm.key}`,attrs:{"slot":"button-prev"},slot:"button-prev"}),_c('div',{class:`swiper-button-next next${_vm.key}`,attrs:{"slot":"button-next"},slot:"button-next"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }